<div class="books-modal-wrapper">
    <div class="row">
        <div class="col-md-12">
            <div class="header-modal ">
                <button (click)="close()" data-modal-element-close-button="" class="modal-close-button" data-modal-close="" aria-label="Close Getting started section">
                    <span data-modal-element-close-icon="" class="modal-close-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.12,10l4.07-4.06a1.5,1.5,0,1,0-2.11-2.12L10,7.88,5.94,3.81A1.5,1.5,0,1,0,3.82,5.93L7.88,10,3.81,14.06a1.5,1.5,0,0,0,0,2.12,1.51,1.51,0,0,0,2.13,0L10,12.12l4.06,4.07a1.45,1.45,0,0,0,1.06.44,1.5,1.5,0,0,0,1.06-2.56Z"></path></svg></span>
                </button>
            </div>
        </div>
    </div>
    
    <div class="row">
        
        <div class="col-md-12">
            <div class="img mb-md-0 mb-4">
                <img  [src]="selectedImg.img" alt="CAT 2024">
                <div class="lb-nav">
                    <a (click)="prev()" class="lb-prev">
                    </a>
                    <a (click)="next()" class="lb-next">
                    </a>
                </div>
            </div>
        </div>
        
    </div>

    <div class="row">
        <div class="gallery-text">
            <p>Image {{data?.index + 1}} of {{data?.images.length}}</p>
        </div>
    </div>
</div>